import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Model from "./Pages/Componant/Model";
import Purchase from "./Pages/Componant/Purchase";
import CashPurchase from "./Pages/Componant/Cash_purchase";
import Sale from "./Pages/Componant/Sale";
import Model_table from "./Pages/Componant/Model_table";
import Purchase_table from "./Pages/Componant/Purchase_table";
import CashPurchase_table from "./Pages/Componant/CashPurchase_table";
import PurchaseList_for_user from "./Pages/Componant/PurchaseList_for_user";
import Sale_table from "./Pages/Componant/Sale_table";
import Sale_BuyBack_Table from "./Pages/Componant/Sale_BuyBack_Table";
import Invoice from "./Pages/Componant/Invoice";
import Purchase_invoice from "./Pages/Componant/Purchase_invoice";
import Leager_customer from "./Pages/Componant/Leager_customer";
import Purchase_payable from "./Pages/Componant/Purchase_payable";
import Sale_payable from "./Pages/Componant/Sale_payable";
import Dailybook from "./Pages/Componant/Dailybook";
import Model_update from "./Pages/Componant/Model_update";
import Purachse_update from "./Pages/Componant/Purachse_update";
import Sale_update from "./Pages/Componant/Sale_update";
import Users from "./Pages/Componant/Users";
import Login from "./Pages/Header/Login";
import Dailybook_table from "./Pages/Componant/Dailybook_table";
import User_udate from "./Pages/Componant/User_udate";
import Dailybook_update from "./Pages/Componant/Dailybook_update";
import { AuthProvider } from "./Pages/Header/AuthContext";
import Leager_customer_table from "./Pages/Componant/Leager_customer_table";
import Leager_suppiler_table from "./Pages/Componant/Leager_suppiler_table";
import Leager_suppiler from "./Pages/Componant/Leager_suppiler";
import Purchase_payable_table from "./Pages/Componant/Purchase_payable_table";
import Purchase_payable_update from "./Pages/Componant/Purchase_payable_update";
import Purchase_report from "./Pages/Componant/Purchase_report";
import Sale_report from "./Pages/Componant/Sale_report";
import Dailybook_leager from "./Pages/Componant/Dailybook_leager";
import Dailybook_leager_table from "./Pages/Componant/Dailybook_leager_table";
import Leager_general_table from "./Pages/Componant/Leager_general_table";
import Leager_general from "./Pages/Componant/Leager_general";
import Supplier_details from "./Pages/Componant/Supplier_details";
import Supplier_details_table from "./Pages/Componant/Supplier_details_table";
import Supplier_update from "./Pages/Componant/Supplier_update";
import User_ModelList from "./Pages/Componant/User_ModelList";
import Expense_details from "./Pages/Componant/Expense_details";
import Expense_table from "./Pages/Componant/Expense_table";
import Expense_update from "./Pages/Componant/Expense_update";
import Today_profit from "./Pages/Componant/Today_profit";
import Daily_stock from "./Pages/Componant/Daily_stock";
import Enquiry from "./Pages/Componant/Enquiry";
import Enquiry_table from "./Pages/Componant/Enquiry_table";
import Enquiry_update from "./Pages/Componant/Enquiry_update";
import IMEI_transactions from "./Pages/Componant/IMEI_transactions";


function App() {

  const isLoggedIn=()=>{
    const loggedIn=localStorage.getItem('isLoggedIn');
    return loggedIn==='true';
  };

  const PrivateRoute = ({element})=>{
    return isLoggedIn() ? element : <Navigate to="/login" />;
  }

  
  return (
    <div className="App">
      
      <Router>
      <AuthProvider>
        <Routes>

          <Route path="/login" element={<Login/>} />
          <Route path="/" element={<PrivateRoute element={<Dashboard/>}/>} />
          {/* <Route path="*" element={<PrivateRoute element={<Page404/>}/>} /> */}
         

          <Route path="/model" element={<PrivateRoute element={<Model/>}/>} />
          <Route path="/model_table" element={<PrivateRoute element={<Model_table/>}/>} />
          <Route path="/model_update" element={<PrivateRoute element={<Model_update/>}/>} />

          <Route path="/suppiler" element={<PrivateRoute element={<Supplier_details/>}/>} />
          <Route path="/suppiler_table" element={<PrivateRoute element={<Supplier_details_table/>}/>} />
          <Route path="/suppiler_update" element={<PrivateRoute element={<Supplier_update/>}/>} />

          <Route path="/purchase" element={<Purchase />} />
          <Route path="/cash_purchase" element={<PrivateRoute element={<CashPurchase/>}/>} />
          <Route path="/cash_purchase_table" element={<PrivateRoute element={<CashPurchase_table/>}/>} />
          <Route path="/purchase_table" element={<PrivateRoute element={<Purchase_table/>}/>} />
          <Route path="/purchaselist_for_user" element={<PrivateRoute element={<PurchaseList_for_user/>}/>} />
          <Route path="/purchase_update" element={<PrivateRoute element={<Purachse_update/>}/>} />

          <Route path="/purchase_invoice" element={<PrivateRoute element={<Purchase_invoice/>}/>} />


          <Route path="/purchase_payable" element={<PrivateRoute element={<Purchase_payable/>}/>} />
          <Route path="/purchase_payable_table" element={<PrivateRoute element={<Purchase_payable_table  />}/>} />
          <Route path="/purchase_payable_update" element={<PrivateRoute element={<Purchase_payable_update/>}/>} />

          <Route path="/purchase_report" element={<PrivateRoute element={<Purchase_report/>}/>} />


          <Route path="/sale" element={<PrivateRoute element={<Sale/>}/>} />
          <Route path="/sale_table" element={<PrivateRoute element={<Sale_table/>}/>} />
          <Route path="/sale_update" element={<PrivateRoute element={<Sale_update/>}/>} />
          <Route path="/sale_buyback_table" element={<PrivateRoute element={<Sale_BuyBack_Table/>}/>} />

          {/* Sale payable routes */}
          <Route path="/sale_payable" element={<PrivateRoute element={<Sale_payable/>}/>} />
          <Route path="/sale_payable_table" element={<PrivateRoute element={<Purchase_payable_table  />}/>} />
          <Route path="/purchase_payable_update" element={<PrivateRoute element={<Purchase_payable_update/>}/>} />


          <Route path="/invoice_sale" element={<PrivateRoute element={<Invoice/>}/>} />
          <Route path="/sale_report" element={<PrivateRoute element={<Sale_report/>}/>} />


          <Route path="/dailybook" element={<PrivateRoute element={<Dailybook/>}/>} />
          <Route path="/dailybook_list" element={<PrivateRoute element={<Dailybook_table/>}/>} />
          <Route path="/dailybook_update" element={<PrivateRoute element={<Dailybook_update/>}/>} />
          <Route path="/dailybook_leager_list" element={<PrivateRoute element={<Dailybook_leager_table/>}/>} />
          <Route path="/dailybook_leager" element={<PrivateRoute element={<Dailybook_leager/>}/>} />



          <Route path="/suppiler_leager" element={<PrivateRoute element={<Leager_suppiler/>}/>} />
          <Route path="/supplier_leager_table" element={<PrivateRoute element={<Leager_suppiler_table/>}/>} />


          <Route path="/user" element={<PrivateRoute element={<Users/>}/>} />
          <Route path="/user_update" element={<PrivateRoute element={<User_udate/>}/>} />

          <Route path="/general_leager_table" element={<PrivateRoute element={<Leager_general_table/>}/>} />
          <Route path="/general_leager" element={<PrivateRoute element={<Leager_general/>}/>} />

          <Route path="/user_model_list" element={<PrivateRoute element={<User_ModelList/>}/>} />

          <Route path="/user_model_list" element={<PrivateRoute element={<User_ModelList/>}/>} />

          <Route path="/Expenses" element={<PrivateRoute element={<Expense_details/>}/>} />


          <Route path="/ExpensesList" element={<PrivateRoute element={<Expense_table/>}/>} />
          <Route path="/update_expenseEntry" element={<PrivateRoute element={<Expense_update/>}/>} />

          <Route path="/todayProfit" element={<PrivateRoute element={<Today_profit/>}/>} />
          <Route path="/daily_stock" element={<PrivateRoute element={<Daily_stock/>}/>} />

          <Route path="/enquiry" element={<PrivateRoute element={<Enquiry/>}/>} />
          <Route path="/enquiryList" element={<PrivateRoute element={<Enquiry_table/>}/>} />
          <Route path="/enquiryupdate" element={<PrivateRoute element={<Enquiry_update/>}/>} />

          <Route path="/imei_transactions" element={<PrivateRoute element={<IMEI_transactions/>}/>} />






        </Routes>
        </AuthProvider>
      </Router>
      

     
    </div>
  );
}

export default App;
